import React from "react";
import { OM_LOGO, MTN_LOGO, OPERATOR_COLORS } from "../../assets/logos";

/**
 * Sélecteur d'opérateur (Orange Money / MTN MoMo)
 * @param {string} value - "o" | "m"
 * @param {function} onChange
 * @param {"full"|"short"} labelStyle - affiche "Orange Money" ou "Orange"
 */
export default function OperatorSelector({ value, onChange, labelStyle = "full" }) {
  const ops = [
    { key: "o", logo: OM_LOGO, logoH: "20px", label: labelStyle === "full" ? "Orange Money" : "Orange" },
    { key: "m", logo: MTN_LOGO, logoH: "18px", label: labelStyle === "full" ? "MTN MoMo" : "MTN" },
  ];

  return (
    <div className="grid grid-cols-2 gap-1.5">
      {ops.map(({ key, logo, logoH, label }) => {
        const col = OPERATOR_COLORS[key];
        const selected = value === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className="cursor-pointer border-2 rounded-[12px] py-2.5 px-2 bg-white text-center transition-all tap-highlight"
            style={{
              borderColor: selected ? col.primary : "#e5e7eb",
            }}
          >
            <img src={logo} alt={label} style={{ height: logoH }} className="mx-auto mb-1 block" />
            <p
              className="text-[10px] font-bold"
              style={{ color: selected ? col.primary : "#6b7280" }}
            >
              {label}
            </p>
          </button>
        );
      })}
    </div>
  );
}
